export default {
    baseStyle: {
        title: {
            fontSize: {
                base: '23px',
                lg: '26px'
            },
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: '0.12px',
            color: 'black.100',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            sx: {
                lineClamp: '2',
                WebkitLineClamp: '2',
                WebkitBoxOrient: 'vertical'
            }
        },
        setTitle: {
            fontSize: {
                base: '24px'
            },
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: '0.12px',
            color: 'black.100',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            fontFamily: 'caslon',
            sx: {
                lineClamp: '2',
                WebkitLineClamp: '2',
                WebkitBoxOrient: 'vertical'
            }
        },
        price: {
            sx: {
                '& b, & s': {
                    fontFamily: 'heading',
                    fontSize: '26px',
                    lineHeight: 'normal',
                    color: 'gray.800'
                },
                '& s': {
                    textUnderlineOffset: '-0.23em',
                    textDecoration: 'underline',
                    textDecorationSkipInk: 'none',
                    textDecorationThickness: '1px'
                }
            }
        },
        cartButton: {
            height: '56px',
            fontSize: '17px',
            letterSpacing: '0.5%',
            lineHeight: '26px'
        },
        variationsStack: {
            labelBox: {
                fontWeight: '400',
                fontSize: '16px',
                color: 'black.100',
                display: 'flex'
            }
        },
        viewWrapper: {
            invalidSelection: {
                color: 'red.400',
                fontSize: '14px',
                letterSpacing: '0.07px',
                lineHeight: '22px',
                fontWeight: '400',
                whiteSpace: 'normal'
            }
        },
        promotion: {
            background: 'green.100',
            color: 'green.500',
            paddingX: '8px',
            paddingY: '4px',
            borderRadius: '3px',
            fontSize: '13px',
            lineHeight: '22px',
            letterSpacing: '0.065px',
            fontWeight: 400
        },
        startingAt: {
            color: 'black.100',
            fontFamily: 'heading',
            fontSize: '26px',
            lineHeight: 'normal',
            letterSpacing: '0.115px',
            fontWeight: '400',
            marginRight: '6px'
        },
        engravingWrapper: {
            main: {
                borderRadius: '3px',
                border: '0.5px solid',
                backgroundColor: 'white',
                borderColor: 'black.300',
                padding: '15px 20px'
            }
        },
        mobileEngravingBanner: {
            main: {
                display: {base: 'flex', lg: 'none'},
                backgroundColor: 'black.300',
                padding: '10px 15px',
                justifyContent: 'space-between',
                cursor: 'pointer',
                alignItems: 'center'
            },
            textBox: {
                color: 'white',
                fontFamily: 'heading',
                fontSize: '15px',
                fontWeight: '400'
            }
        },
        AddEngravingButton: {
            main: {
                alignItems: 'center',
                variant: 'outline',
                width: '100%',
                borderRadius: '90px',
                borderColor: 'black.300',
                backgroundColor: 'transparent',
                _hover: {
                    backgroundColor: 'gray.425 !important'
                },
                marginTop: '15px',
                gap: '10px',
                height: '56px'
            },
            text: {
                color: 'black.100',
                fontSize: '17px',
                fontWeight: '400',
                letterSpacing: '0.085px'
            }
        },
        EditEngravingButton: {
            main: {
                alignItems: 'center',
                variant: 'outline',
                width: '100%',
                borderRadius: '90px',
                background: 'black.300',
                marginTop: '15px',
                gap: '10px',
                height: '56px',
                _hover: {
                    background: 'black.50'
                }
            },
            text: {
                color: 'white',
                fontSize: '17px',
                fontWeight: '400',
                letterSpacing: '0.085px'
            }
        },
        welInstitute: {
            sx: {
                '& .ks-wel-institute': {
                    padding: '15px 20px',
                    gap: '10px',
                    display: 'grid',
                    borderRadius: '3px',
                    lineHeight: '28px',
                    backgroundColor: 'gray.50',
                    '& .ks-wel-institute-title': {
                        color: 'mango.400',
                        fontFamily: 'heading',
                        fontSize: '23px',
                        fontWeight: '400',
                        letterSpacing: '0.115px'
                    },
                    '& .ks-wel-institute-description': {
                        fontSize: '14px',
                        fontWeight: '300',
                        lineHeight: '22px',
                        letterSpacing: '0.07px',
                        color: 'black.100'
                    }
                }
            }
        },
        disclaimerText: {
            color: 'gray.800',
            fontSize: '14px',
            fontWeight: '300',
            padding: '15px 0',
            borderTop: '0.5px solid',
            borderBottom: '0.5px solid',
            borderColor: 'gray.450'
        },
        commonLink: {
            textDecoration: 'underline',
            color: 'black.100',
            fontSize: '16px',
            fontWeight: '300',
            marginTop: '20px',
            lineHeight: '25px',
            letterSpacing: '0.08px',
            textUnderlineOffset: '4px',
            transition: 'color 0.3s ease',
            _hover: {
                color: 'blue.700'
            }
        },
        viewDetailsLink: {
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: '300',
            fontFamily: 'body',
            textTransform: 'capitalize',
            textDecoration: 'underline',
            color: 'black.100',
            marginTop: {base: '0px', md: '10px'},
            display: 'block',
            cursor: 'pointer'
        }
    },
    variants: {
        YR: {
            title: {
                fontFamily: 'caslon'
            }
        },
        KS: {
            title: {
                fontFamily: 'cormorant'
            }
        }
    }
}
